import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { MapIntegrationPlanForm } from "../MapIntegrationPlanForm";
import { CreateMapIntegrationPlanModalProps } from "./types";
import { useCreateMapIntegrationPlanModal } from "./controller";

export const CreateMapIntegrationPlanModal = React.memo(({ modalRef, agreement }: CreateMapIntegrationPlanModalProps) => {
  const translate = useTranslate();

  const { methods, mutateAsync, isPending } = useCreateMapIntegrationPlanModal(modalRef);

  return (
    <Modal
      ref={modalRef}
      title={translate("subscription_mapintegrationplan_admin.titles.create")}
      onConfirm={mutateAsync}
      methods={methods}
      isPending={isPending}
    >
      <MapIntegrationPlanForm agreement={agreement} multiplePlans={true} />
    </Modal>
  );
});
